function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import Accordion from '@mozaic-ds/freemarker/js/modules/_accordion.js';
import Video from 'integration-web-core--socle/js/assets/modules/_video.class';
var FaqEnrichment = /*#__PURE__*/function (_lm$Composant) {
  function FaqEnrichment(id) {
    var _this;
    _classCallCheck(this, FaqEnrichment);
    _this = _callSuper(this, FaqEnrichment, [id]);
    _this.initAccordions(id);
    new Video();
    return _this;
  }
  _inherits(FaqEnrichment, _lm$Composant);
  return _createClass(FaqEnrichment, [{
    key: "scrollToFaqElement",
    value: function scrollToFaqElement(id) {
      var targetElement = window.location.hash.substring(1).split('?')[0];
      if (targetElement) {
        var question = document.querySelector("#".concat(id, " #").concat(targetElement));
        if (question) {
          var _document$querySelect;
          this.openFaqElement(question);
          var questionPositionTop = (question === null || question === void 0 ? void 0 : question.getBoundingClientRect().top) + window.scrollY;
          var headerHeight = (_document$querySelect = document.querySelector('.l-header__components')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.offsetHeight;
          var scrollPosition = questionPositionTop - headerHeight;
          window.scrollTo({
            top: scrollPosition,
            behavior: 'smooth'
          });
        }
      }
    }
  }, {
    key: "openFaqElement",
    value: function openFaqElement(targetElement) {
      var elemToClick = targetElement.querySelector('.js-accordion__trigger');
      if (elemToClick.getAttribute('aria-expanded') === 'false') {
        elemToClick.click();
      }
    }
  }, {
    key: "initAccordions",
    value: function initAccordions(id) {
      var _this2 = this;
      var accordionsFaq = document.querySelectorAll("#".concat(id, " .js-accordion"));
      accordionsFaq.forEach(function (accordion) {
        new Accordion(accordion);
        _this2.initPrivacyToggleComponent(accordion.querySelector('.mc-accordion__content'));
        _this2.initPrivacyToggleCookieChange(accordion.querySelector('.mc-accordion__content'));
      });
    }
  }, {
    key: "initPrivacyToggleComponent",
    value: function initPrivacyToggleComponent(targetElement) {
      var PRIVACY_TOGGLE_REGEX = /\{\{PRIVACY_TOGGLE::"(.*?)"\}\}/g;
      targetElement.innerHTML = targetElement.innerHTML.replace(PRIVACY_TOGGLE_REGEX, function (match, consentText) {
        var uniqueId = "acceptAudience--".concat(Math.floor(Math.random() * 1000));
        var isToggleCheckedOnDomLoaded = lm.cookie.get("pa_privacy").includes('optin') || lm.cookie.get("pa_privacy").includes('exempt');
        return "\n          <div class=\"mc-toggle\" style=\"padding-top:1rem;padding-bottom:1rem\">\n              <input class=\"mc-toggle__input js-acccept-audience\" type=\"checkbox\" id=\"".concat(uniqueId, "\" name=\"acceptAudience\" ").concat(isToggleCheckedOnDomLoaded ? "checked" : "", ">\n              <label class=\"mc-toggle__label\" for=\"").concat(uniqueId, "\">\n                  <span class=\"mc-toggle__content\">\n                      ").concat(consentText, "\n                  </span>\n              </label>\n          </div>\n      ");
      });
    }
  }, {
    key: "initPrivacyToggleCookieChange",
    value: function initPrivacyToggleCookieChange(targetElement) {
      var _this3 = this;
      var audienceToggleList = targetElement.querySelectorAll('.js-acccept-audience');
      if (audienceToggleList) {
        audienceToggleList.forEach(function (toggle) {
          _this3.changePrivacyToggle(toggle);
          targetElement.closest('.js-accordion').querySelector('.js-accordion__trigger').addEventListener('click', function () {
            _this3.changePrivacyToggle(toggle);
          });
          toggle.addEventListener('change', function (event) {
            if (event.target.checked) {
              lmpa.setOptout(false);
            } else {
              lmpa.setOptout(true);
            }
          });
        });
      }
    }
  }, {
    key: "changePrivacyToggle",
    value: function changePrivacyToggle(toggle) {
      if (lm.cookie.get("pa_privacy").includes('optout')) {
        toggle.checked = false;
      } else {
        toggle.checked = true;
      }
    }
  }]);
}(lm.Composant);
lm.DOMReady(function () {
  var sectionElem = document.querySelectorAll('.component-faq-enrichment');
  for (var i = 0; i < sectionElem.length; i++) {
    var idElem = sectionElem[i].getAttribute('id');
    if (idElem) {
      var faqEnrichmentModule = {};
      faqEnrichmentModule.instance = new FaqEnrichment(idElem);
      faqEnrichmentModule.instance.scrollToFaqElement(idElem);
      delete faqEnrichmentModule.instance;
    }
  }
});